import { graphql } from "gatsby";
import AnimalDetail from "components/AnimalDetail/AnimalDetail";
import { selectAnimal } from "utils/selectors";
import { useTranslation } from "gatsby-plugin-react-i18next";
import Layout from "components/Layout/Layout";
import BackButton from "components/BackButton/BackButton";
import { motion } from "framer-motion";
import Seo from 'components/Seo/Seo'

const AnimalDetailsPage = ({ data }) => {
  const { t } = useTranslation();

  const animal = selectAnimal(data);
  return (
    <>
      <Layout title={t("Animals in Need")}>
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
          transition={{
            type: "spring",
            mass: 0.35,
            stiffness: 75,
            duration: 0.3,
          }}
        >
          <BackButton to={"/help-an-animal-in-need"} />
        </motion.div>

        <AnimalDetail animal={animal} />
      </Layout>
    </>
  );
};

export default AnimalDetailsPage;

export const query = graphql`
  query ($language: String!, $id: String) {
    animalsJson(id: { eq: $id }) {
      bodyHtml
      bodyTruncated
      category
      gender
      id
      image {
        childImageSharp {
          gatsbyImageData(width: 400, placeholder: BLURRED)
        }
        publicURL
      }
      type
      name
      years
      months
      weight
      parent {
        ... on File {
          name
        }
      }
      gatsbyPath(
        filePath: "/help-an-animal-in-need/{AnimalsJson.parent__(File)__name}"
      )
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export const Head = ({ data }) => {
  const animal = selectAnimal(data);

  return (
    <Seo title={animal.name} description={animal.bodyTruncated} publicImage={animal.images[0].publicURL} />
  )
}
